<main>
  <!-- header START -->
  <div class="container-fluid">
    <app-header (shareUserDetail)="setUserDetails($event)"></app-header>
  </div>
  <!-- header END -->
  @if (userDetail) {
  <div>
    <section class="body-left-insidepages wow animate__fadeInLeft">
      <div class="body-pad">
        <div class="kudoshub-sitemap">
          <h1 class="bdy-centre-mainhead">KudosHub Sitemap</h1>
          <figure class="wave"><img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9">
          </figure>
          <div class="sitemap-links">
            <div class="row">
              <div class="col-sm-4">
                <ul>
                  <li><a href="#" routerLink="/email-validation">Email List Validation</a></li>
                  <li><a href="#" routerLink="/email-marketing">Email Marketing</a></li>
                  <li><a href="#" routerLink="/who-we-are">About KudosHub</a></li>
                  <li><a href="#" routerLink="/web-development">Web Design & Development</a></li>
                  <li><a href="#" routerLink="/free-email-verifier">Free Email Verifier</a></li>
                </ul>
              </div>
              <div class="col-sm-4">
                <ul>
                  <li><a href="#" routerLink="/mobile-app-development">Mobile Applications</a></li>
                  <li><a href="#" routerLink="/why-kudoshub">Why KudosHub</a></li>
                  <li><a href="#" routerLink="/what-we-do">What We Do</a></li>
                  <li><a href="#" routerLink="/get-in-touch">Get In Touch</a></li>
                  <li><a href="#" routerLink="/offers">Offers</a></li>
                  <li><a href="#" routerLink="/bulk-email-verify">Bulk Email Verify</a></li>
                </ul>
              </div>
              <div class="col-sm-4">
                <ul>
                  <li><a href="#" routerLink="/career-with-us">Career With Us</a></li>
                  <li><a href="#" routerLink="/docs">Documentation</a></li>
                  <li><a href="#" routerLink="/integration">Integration</a></li>
                  <li><a href="#" routerLink="/our-policies">Our Policies</a></li>
                  <li><a href="#" routerLink="/email-validation-api">Email Validation API</a></li>
                  <li><a href="#" routerLink="/email-checker">Email Checker</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="sitemap wow animate__fadeInUp">
            <h2 class="bdy-left-mainhead">Integration</h2>
            <figure class="wave">
              <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" />
            </figure>
            <div class="sitemap-links">
              <div class="row">
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/integration/mailchimp">Mailchimp</a></li>
                    <li><a href="#" routerLink="/integration/hubspot">Hubspot</a></li>
                    <li><a href="#" routerLink="/integration/aweber">Aweber</a></li>
                    <li><a href="#" routerLink="/integration/drip">Drip</a></li>
                    <li><a href="#" routerLink="/integration/klaviyo">Klaviyo</a></li>
                  </ul>
                </div>
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/integration/zapier">Zapier</a></li>
                    <li><a href="#" routerLink="/integration/icontact">Icontact</a></li>
                    <li><a href="#" routerLink="/integration/constant-contact">Constant Contact</a></li>
                    <li><a href="#" routerLink="/integration/mailgun">Mailgun</a></li>
                    <li><a href="#" routerLink="/integration/infusion-soft">Infusion Soft</a></li>
                  </ul>
                </div>
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/integration/zoho">Zoho</a></li>
                    <li><a href="#" routerLink="/integration/get-response">Get Response</a></li>
                    <li><a href="#" routerLink="/integration/marketo">Marketo</a></li>
                    <li><a href="#" routerLink="/integration/googlesheets">Google Sheets</a></li>
                    <li><a href="#" routerLink="/integration/active-campaign">Active Campaign</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="sitemap wow animate__fadeInUp">
            <h2 class="bdy-left-mainhead">Documentation</h2>
            <figure class="wave">
              <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" />
            </figure>
            <div class="sitemap-links">
              <div class="row">
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/docs">Getting Started</a></li>
                  </ul>
                </div>
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/docs/email-validation">Email Validation</a></li>
                  </ul>
                </div>
                <div class="col-sm-4">
                  <ul>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="sitemap wow animate__fadeInUp">
            <h2 class="bdy-left-mainhead">Registration / Login</h2>
            <figure class="wave">
              <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" />
            </figure>
            <div class="sitemap-links">
              <div class="row">
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/register">Register</a></li>
                  </ul>
                </div>
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/login">Login</a></li>
                  </ul>
                </div>
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/forgot-password">Forgot Password</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="sitemap wow animate__fadeInUp">
            <h2 class="bdy-left-mainhead">Compare Pages</h2>
            <figure class="wave">
              <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" />
            </figure>
            <div class="sitemap-links">
              <div class="row">
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/zerobounce-alternative">Kudoshub vs Zerobounce</a></li>
                    <li><a href="#" routerLink="/neverbounce-alternative">Kudoshub vs Neverbounce</a></li>
                    <li><a href="#" routerLink="/briteverify-alternative">Kudoshub vs Briteverify</a></li>
                    <li><a href="#" routerLink="/debounce-alternative">Kudoshub vs Debounce</a></li>
                  </ul>
                </div>
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/cleanify-alternative">Kudoshub vs Cleanify</a></li>
                    <li><a href="#" routerLink="/email-validator-alternative">Kudoshub vs Email Validator</a></li>
                    <li><a href="#" routerLink="/blazeverify-alternative">Kudoshub vs Blazeverify</a></li>
                    <li><a href="#" routerLink="/kickbox-alternative">Kudoshub vs Kickbox</a></li>
                  </ul>
                </div>
                <div class="col-sm-4">
                  <ul>
                    <li><a href="#" routerLink="/impressionwise-alternative">Kudoshub vs Impressionwise</a></li>
                    <li><a href="#" routerLink="/emaillistverify-alternative">Kudoshub vs Emaillistverify</a></li>
                    <li><a href="#" routerLink="/xverify-alternative">Kudoshub vs Xverify</a></li>
                    <li><a href="#" routerLink="/webbula-alternative">Kudoshub vs Webbula</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <app-footer></app-footer>
    </section>
    <section class="body-right-insidepages animate__animated animate__fadeInRight"> <a routerLink="/">
        <div class="pic-area">
          <div class="pic-zoom box02"></div>
          <div class="page-head">
            <div class="cross"><img src="theme/images/cross.svg" width="25" alt="cross"></div>
            <h2>Sitemap <img src="theme/images/offers-kudoshub-icon.svg" width="40" alt="Who we are KudosHub"
                class="icon-pad"></h2>
          </div>
        </div>
      </a>
    </section>
  </div>
  }
</main>